export default "__VITE_ASSET__dbfb44b3__"